export default "__VITE_ASSET__CApjEj8o__"